import request from 'axios'

// 导出Excel公用方法
export function exportMethod (data) {
   request({
        method: data.method,
        url: data.url,
        responseType: 'blob',
        headers: {
            'Authorization':'Bearer'+window.localStorage.getItem('Admin-Token'),
        },
    }).then((res) => {
    const link = document.createElement('a')
    let blob = new Blob([res.data])
    link.style.display = 'none'
    link.href = URL.createObjectURL(blob)

    // link.download = res.headers['content-disposition'] //下载后文件名
    link.download = data.fileName //下载的文件名
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }).catch(error => {
    this.$message.error({
      title: '错误',
      desc: '网络连接错误'
    })
    console.log(error)
  })
}


/**
 * 验证是否为已定义的值
 * @params val -> 值
 * @returns { Boolean }
 */
export function isDef (val) {
  return !(isType(val, 'Null') || isType(val, 'Undefined'))
}

/**
 * 得到距离指定日期多少天的日期
 * @param {Int} days 多少天
 * @param {String} startDate 规格为yyyy-mm-dd的指定日期，不传默认为当天
 * @returns { String } 规格为yyyy-mm-dd的字符串
 */
export function getDate (days, startDate,format = '{y}-{m}-{d}') {
  const date = startDate ? new Date(startDate) : new Date()
  date.setDate(date.getDate() + days)
  return parseTime(date, format)
}

/**
 * 时间格式化
 * @param {Int | Date} time 时间戳 | 时间对象参数
 * @param {String} [cFormat = '{y}-{m}-{d} {h}:{i}:{s}'] 输出时间日期格式，默认{y}-{m}-{d} {h}:{i}:{s}
 * cFormat:
 *   y-年
 *   m-月
 *   d-日
 *   h-时
 *   i-分
 *   s-秒
 *   a-星期
 * @returns { String } 规格为cFormat的字符串
 */
export function parseTime (time, cFormat) {
  if (arguments.length === 0) {
    return undefined
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
 * @desc 函数防抖
 * @param func 函数
 * @param wait 延迟执行毫秒数
 * @param immediate true 表立即执行，false 表非立即执行
 */
export function debounce (func, wait, immediate = false) {
  let timeout
  return function () {
    const context = this
    const args = arguments

    if (timeout) clearTimeout(timeout)
    if (immediate) {
      const callNow = !timeout
      timeout = setTimeout(() => {
        timeout = null
      }, wait)
      if (callNow) func.apply(context, args)
    } else {
      timeout = setTimeout(function () {
        func.apply(context, args)
      }, wait)
    }
  }
}
// 格式化日期
export function formatDate(date, format = 'YYYY-MM-DD HH:mm:ss') {
  if (!date) return ''

  const d = new Date(date)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const hours = String(d.getHours()).padStart(2, '0')
  const minutes = String(d.getMinutes()).padStart(2, '0')
  const seconds = String(d.getSeconds()).padStart(2, '0')

  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds)
}
